import type { ReactNode } from 'react'

/**
 * Paylaşılan Badge bileşeni (013 tasarım dili). İki varyant:
 *  - `soft`: dolgulu tonlu pill (Talep Türü gibi etiketler) — Figma: #f1f5f9 zemin, radius 6, 12/600.
 *  - `dot`:  zemin yok, renkli nokta + renkli metin (Durum rozeti) — Figma: 12/600 tonlu.
 * Ton eşlemeleri token/Figma renklerinden; `StatusTag` bunu durum-id → ton ile kullanır (tek kaynak).
 */
export type BadgeTone = 'neutral' | 'blue' | 'green' | 'red'
export type BadgeVariant = 'soft' | 'dot'

export interface BadgeProps {
  children: ReactNode
  tone?: BadgeTone
  variant?: BadgeVariant
}

export default function Badge({ children, tone = 'neutral', variant = 'soft' }: Readonly<BadgeProps>) {
  return (
    <span className={`ui-badge ui-badge-${variant} t-${tone}`}>
      {variant === 'dot' && <span className="ui-badge-marker" aria-hidden />}
      {children}
    </span>
  )
}
